import { Text } from 'app/design/primitives/text';
import { type Profile } from 'app/network/profile';

export function ProfileBio({ profile }: { profile: Profile | undefined }) {
  if (!profile?.bio) return null;
  return (
    <Text variant="bodyBase" color="text.primary" style={{ fontStyle: 'italic', lineHeight: 20 }}>
      {profile.bio}
    </Text>
  );
}
